import AuthContextProvider from "../../contexts/AuthContext"
import FirebaseConnectionProvider from "../../contexts/FirebaseConnectionContext"
import ModalContextProvider from "../../contexts/ModalContext"

const IndexProviders = ({ children }) => {

    return (
        <AuthContextProvider>
            <FirebaseConnectionProvider>
                <ModalContextProvider>
                    {children}
                </ModalContextProvider>
            </FirebaseConnectionProvider>
        </AuthContextProvider>
    )
}

export default IndexProviders